import { RawCellDatum } from './types';

export function must<T>(d: T | null | undefined): T {
  if (d === null || d === undefined) {
    throw new Error(`${d} is null/undefined`);
  }
  return d;
}

export function cellToNumber(d: RawCellDatum): number | null {
  if (d == null) {
    return null;
  } else if (typeof d === 'number') {
    return d;
  }
  throw new Error(`${d} is not a number`);
}

export function cellToString(d: RawCellDatum): string | null {
  if (d == null) {
    return null;
  } else if (typeof d === 'string') {
    return d;
  } else if (typeof d === 'number') {
    return d.toString();
  }
  throw new Error(`${d} is not a string`);
}

export function cellToBool(d: RawCellDatum): boolean | null {
  if (d == null) {
    return null;
  } else if (typeof d === 'boolean') {
    return d;
  }
  throw new Error(`${d} is not a bool`);
}
